import React from 'react';
import { useTranslation } from 'react-i18next';

// Editor del Acuerdo de Procesamiento de Datos (DPA) — Consultame, NER-3832,
// spec §Compliance P0.2. Muestra la versión y el texto. `editable` habilita la
// edición del texto (uso admin); en el wizard se muestra read-mostly con un
// checkbox de aceptación. Emite onChange(text) al editar y onAccept(bool).
function DPAConsentEditor({ text, version, editable, accepted, onChange, onAccept }) {
  const { t } = useTranslation();

  return (
    <div className="med-dpa">
      <div className="med-dpa-head">
        <span className="med-dpa-title">
          <span className="material-icons">verified_user</span>
          {t('setupWizardMedical.dpa.title', 'Acuerdo de Procesamiento de Datos (DPA)')}
        </span>
        <span className="med-dpa-version">
          {t('setupWizardMedical.dpa.version', { version, defaultValue: 'Versión {{version}}' })}
        </span>
      </div>

      {editable ? (
        <textarea
          className="sw-input med-dpa-textarea"
          rows={12}
          value={text}
          onChange={(e) => onChange && onChange(e.target.value)}
        />
      ) : (
        <pre className="med-dpa-text">{text}</pre>
      )}

      {typeof onAccept === 'function' && (
        <label className="med-consent-check">
          <input type="checkbox" checked={!!accepted} onChange={(e) => onAccept(e.target.checked)} />
          <span>
            {t(
              'setupWizardMedical.dpa.accept',
              'Acepto el acuerdo de procesamiento de datos como Responsable de los datos de mis pacientes.'
            )}
          </span>
        </label>
      )}
    </div>
  );
}

export default DPAConsentEditor;
